module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_l"
  }, [_c('div', {
    staticClass: "tea_nav_title"
  }, [_vm._v(_vm._s(_vm.newsTitle))]), _vm._v(" "), _c('div', {
    staticClass: "tea_nav"
  }, [_c('ul', _vm._l((_vm.types), function(type, index) {
    return (type.homeDisplay === 1) ? _c('li', {
      key: index,
      class: _vm.on[type.id],
      on: {
        "click": function($event) {
          _vm.focus(type.id);
          _vm.selectName(type.id);
          _vm.pushToNew();
        }
      }
    }, [_vm._v(_vm._s(_vm.showType(type)))]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._l((_vm.hotNews), function(newsitem, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: 'hot' + index,
      staticClass: "more_box"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(newsitem),
        "href": _vm.href(newsitem)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(newsitem)
        }
      }
    }, [_c('div', {
      staticClass: "more_l"
    }, [_vm._v("\n              " + _vm._s(newsitem.createdAt.split(' ')[0]) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "more_r"
    }, [_c('span', {
      staticClass: "nhott"
    }, [_vm._v("HOT")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(newsitem.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.normalNews), function(newsitem, index) {
    return (_vm.inCurrentPage(_vm.hotNews.length + index)) ? _c('div', {
      key: index,
      staticClass: "more_box"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(newsitem),
        "href": _vm.href(newsitem)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(newsitem)
        }
      }
    }, [_c('div', {
      staticClass: "more_l"
    }, [_vm._v("\n              " + _vm._s(newsitem.createdAt.split(' ')[0]) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "more_r"
    }, [_c('span', [_vm._v(_vm._s(newsitem.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    staticStyle: {
      "margin-top": "100px"
    },
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.news.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "newsitem": _vm.newsitem
    },
    on: {
      "initNews": _vm.initNews
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7774c643","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/News.vue
// module id = 1283
// module chunks = 4